import BadgeCellRenderer from '@gu-datagrid-new/cell-renderers/BadgeCellRenderer.vue'

import PgeCompaniesIsAdminCellRenderer from '@customers/pge/components/cell-renderers/PgeCompaniesIsAdminCellRenderer.vue'
import PgeCompaniesMemberActionsCellRenderer from '@customers/pge/components/cell-renderers/PgeCompaniesMemberActionsCellRenderer.vue'
import PgeCompaniesMemberApplicationAccessCellRenderer from '@customers/pge/components/cell-renderers/PgeCompaniesMemberApplicationAccessCellRenderer.vue'

const defaultColDef = {
  menuTabs: [
    'filterMenuTab',
    'generalMenuTab',
    'columnsMenuTab',
  ],
  resizable: true,
  sortable: true,
  filter: true,
  // Brief yellow flash when a cell's value changes (e.g. after a rule action
  // returns UPDATE_FIELD_VALUE). Matches Vue2 PG&E grid behavior.
  enableCellChangeFlash: true,
}

const baseColumnDefs = [
  {
    field: 'rowId',
    hide: true,
  },
  {
    headerName: '',
    field: 'Type',
    cellRenderer: PgeCompaniesIsAdminCellRenderer,
    sortable: false,
    filter: false,
    width: 48,
    minWidth: 48,
    suppressHeaderMenuButton: true,
  },
  {
    headerName: 'Name',
    field: 'Full Name',
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true },
    minWidth: 200,
  },
  {
    headerName: 'Account',
    field: 'Account Name',
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true },
    minWidth: 200,
  },
  {
    headerName: 'Email',
    field: 'Email',
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true },
    minWidth: 200,
  },
  {
    headerName: 'Role',
    field: 'Type',
    cellRenderer: BadgeCellRenderer,
    cellRendererParams: {
      variant: {
        admin: 'primary',
        Admin: 'primary',
        member: 'secondary',
        Contractor: 'secondary',
      },
    },
    filter: 'agSetColumnFilter',
    minWidth: 120,
  },
  {
    headerName: 'Application Access',
    field: 'Application Access',
    cellRenderer: PgeCompaniesMemberApplicationAccessCellRenderer,
    sortable: false,
    filter: false,
    minWidth: 160,
  },
  {
    headerName: 'Status',
    field: 'Status',
    cellRenderer: BadgeCellRenderer,
    cellRendererParams: {
      variant: {
        Approved: 'success',
        Active: 'success',
        Disabled: 'danger',
        Invited: 'warning',
        'Request Pending': 'warning',
      },
    },
    filter: 'agSetColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      values: ['Approved', 'Active', 'Disabled', 'Invited', 'Request Pending'],
    },
    minWidth: 140,
  },
  {
    headerName: 'Actions',
    field: 'Status',
    cellRenderer: PgeCompaniesMemberActionsCellRenderer,
    sortable: false,
    filter: false,
    minWidth: 240,
    pinned: 'right',
    suppressHeaderMenuButton: true,
  },
]

export function buildPgeMembersGridConfig ({ rowData, context } = {}) {
  return {
    defaultColDef,
    columnDefs: baseColumnDefs,
    rowData: rowData ?? [],
    pagination: true,
    // Vue2 PG&E parity: Export CSV/Excel button in the toolbar.
    enableExportButton: true,
    exportButtonSettings: {
      defaultFilename: 'Company Members Export',
      header: 'Export Members',
    },
    enableMultirowSelect: false,
    enablePresets: false,
    enableQuickFilter: true,
    showActiveFilters: true,
    gridOptions: {
      // Vue2 PG&E parity: row count summary in the bottom status bar.
      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
          { statusPanel: 'agTotalRowCountComponent', align: 'center' },
          { statusPanel: 'agFilteredRowCountComponent', align: 'center' },
        ],
      },
      // Vue2 PG&E parity: page size auto-fits to available container height.
      paginationAutoPageSize: true,
      defaultColumnId: 'id',
      context: context ?? {},
      overlayNoRowsTemplate: '<div class="alert alert-info">No users in company</div>',
    },
  }
}
